import React from 'react';
import { IcoDone } from 'icons';
import { Link, View, Text, isWeb } from 'core';
import { style, theme } from 'constants';

export const Checkbox = ({ value, onValueChange, title, children, style, color, text_color, size, ...props }) => {
  size = size || 22;
  size = isWeb ? size : size + 4;
  const icon_size = size - 14;
  color = color || theme.primary_color;
  const radius = size / 2;
  const Comp = onValueChange ? Link : View;
  return (
    <Comp onPress={() => onValueChange(!value)} style={[styles.row, style]} {...props}>
      <View style={[styles.circle, { width: size, height: size, borderColor: color, borderRadius: radius }, value && { backgroundColor: color }]}>
        {value ? <IcoDone size={icon_size} color="white" /> : null}
      </View>
      <Text style={{ color: text_color }}>{title}</Text>
      {children}
    </Comp>
  );
};

const styles = style({
  circle: {
    borderWidth: 1,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center'
  },
  row: {
    flexDirection: 'row'
  }
});



// WEBPACK FOOTER //
// ./src/components/core/checkbox.js